import React from "react";
import { Button, ButtonGroup, Container,Card } from "react-bootstrap";
import {
  Rootcontainer,
  SearchDiv,
  MainContainer,
  RootDiv,
  RootTitle,
  RootBal,
  RootRight,
  Amt,
  MoreDetails,
  RootLeft,
  RootValue,
  CustomerStatus,
  BtnGroupRight,
  STBGroup,
  STBDetails,
  CustomerStatusDiv,
  ActivPackage,
  ChannelBox,
  ChannelName,
  ChannelPrice,
  AddPackageHeading
} from "./styled";
import "./index.css";
import { Redirect } from "react-router-dom";
import {
  MdPermIdentity,
  MdHome,
  MdFiberPin,
  MdCreditCard,
  MdRefresh,
  MdAddCircle,
  MdRemoveCircle,
  MdPowerSettingsNew,
  MdArrowBack
} from "react-icons/md";
import loadinggif from "../../assets/loding-gif.gif";
import API from "../../Api";
import logo from "../../assets/logo-3.png";
import LoadingOverlay from "react-loading-overlay";
import BounceLoader from "react-spinners/BounceLoader";
import Drawer from "react-drag-drawer";
import Undraw from "react-undraw";
import GeneralValues from '../../GobelElements/Values';
import { FaPlus,FaCircle } from "react-icons/fa";
import Loader from 'react-loader-spinner';
export default class index extends React.Component {
  constructor(props) {
    super(props);
    console.log("data from search", this.props.specifyUserDetails);
    const data = this.props.specifyUserDetails;
    console.log("data in customer details", data);

    this.state = {
      userMetaData: data,
      userSTBDetails: {},

      isShowAddPackageDialogBox: false,
      isShowRemovePackageDialogBox: false,

      spinnerVisible: false,
      pageCount: 3,
      totalPage: 0,
      count: "",
      lcoID: localStorage.getItem("userID"),
      lcoPassword: localStorage.getItem("userPassword"),
      domainName: localStorage.getItem("domain"),
      pageNo: 3,
      tableDataValue: "",
      isVisibleConformADD_Dialog: false,
      isVisibleConformRemove_Dialog: false,
      isVisibleTransactions_Dialog: false,
      isVisibleRemove_Dialog: false,
      valuePack: 0,
      removeValuePack: 0,
      isShowSuccessDialog: false,
      creditRow: [],
      totalCount: 1,
      isShowLogOutDialog: false,
      inStockListSearchText: "",
           inStockDataList: []
    };

    this.getLCO_Details();
    //this.getdata1()
    console.log("try", this.props.tableData);
  }
  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
  }
  componentWillMount() {
    window.removeEventListener("scroll", this.handleScroll);
  }
  nextPageData(data, pageNo) {
    let lengthOfACustomerList = this.state.creditRow.length;
    // console.log("lenght of the list", this.state.totalCount);
    if (lengthOfACustomerList < this.state.totalCount) {
      // console.log("pageCount", pageNo);
      // this.setState({ animating: true });
      const { lcoID, lcoPassword, domainName } = this.state;
      API.getLCoDebits(lcoID, lcoPassword, "lcod", pageNo, domainName)

        .then(response => response.json())
        .then(responsejson => {
          if (responsejson.count) {
            console.log("SearchResponse", responsejson);
            let oldData = data;
            let newData = oldData.concat(responsejson.content);
            let count = this.state.pageCount + 1;

            this.setState({
              animating: false,
              isShowSearchList: true,
              creditRow: newData,
              pageCount: count
            });
            // console.log("data", this.state.customerList);
            // if (newData.length < responsejson.count) {

            //     this.nextPageData(this.state.customerList, (this.state.pageCount + 1));
            // }
          }
        })
        .catch(err => {
          console.log("error", err);
          this.setState({ isSpinnerVisible: false });
          // break
        });
    }
  }
  getdataPage3(data) {
    const { lcoID, lcoPassword, domainName } = this.state;
    API.getLCoDebits(lcoID, lcoPassword, "lcod", 3, domainName)
      .then(response => response.json())
      .then(responsejson => {
        // console.log("SearchResponse", responsejson);
        let oldData = data;
        let newData = oldData.concat(responsejson.content);
        // if (newData.length < responsejson.count) {

        // this.nextPageData(this.state.customerList, (this.state.pageCount + 1));
        this.setState({
          isSpinnerVisible: false,
          isShowSearchList: true,
          creditRow: newData
        });
        // } else {
        //     this.setState({ isSpinnerVisible: false, isShowSearchList: true, customerList: newData });
        // }
      })
      .catch(err => {
        console.log("error", err);
        this.setState({ isSpinnerVisible: false });
        // break
      });
  }
  getdataPage2(data) {
    const { lcoID, lcoPassword, domainName } = this.state;
    API.getLCoDebits(lcoID, lcoPassword, "lcod", 2, domainName)

      .then(response => response.json())
      .then(responsejson => {
        // console.log("SearchResponse", responsejson);
        let oldData = data;
        let newData = oldData.concat(responsejson.content);
        if (newData.length < responsejson.count) {
          this.getdataPage3(newData);
        } else {
          this.setState({
            isSpinnerVisible: false,
            isShowSearchList: true,
            creditRow: newData
          });
        }
      })
      .catch(err => {
        console.log("error", err);
        this.setState({ isSpinnerVisible: false });
        // break
      });
  }
  getdata1() {
    this.setState({ isSpinnerVisible: true });
    let data = [];
    // if(this.state.initialPageCount <=this.state.totalPageCount){

    const { lcoID, lcoPassword, domainName } = this.state;
    API.getLCoDebits(lcoID, lcoPassword, "lcod", 1, domainName)

      .then(response => response.json())
      .then(responsejson => {
        console.log("SearchResponse", responsejson);
        if (responsejson.message != "no data") {
          let page1Data = [];
          page1Data = responsejson.content;
          console.log("count", page1Data.length);
          this.setState({ totalCount: responsejson.count });
          if (page1Data.length < responsejson.count) {
            this.getdataPage2(page1Data);
          } else {
            this.setState({
              isSpinnerVisible: false,
              isShowSearchList: true,
              creditRow: responsejson.content
            });
          }

          //  this.setState({ isSpinnerVisible: false, isShowSearchList: true,customerList:responsejson.content });
        } else {
          this.setState({ isSpinnerVisible: false, isShowSearchList: false });
          // break
        }
      })
      .catch(err => {
        console.log("error", err);
        this.setState({ isSpinnerVisible: false });
        // break
      });
  }
  handleScroll(e) {
    const bottom =
      e.target.scrollHeight - Math.round(e.target.scrollTop) ===
      e.target.clientHeight;
    console.log(
      "bottom",
      bottom,
      "e.target.scrollHeight:",
      e.target.scrollHeight,
      "e.target.scrollTop:",
      e.target.scrollTop,
      "e.target.clientHeight:",
      e.target.clientHeight
    );
    if (bottom) {
      this.nextPageData(this.state.creditRow, this.state.pageCount + 1);
    }
  }

  getLCO_Details() {
    debugger;
    this.setState({ isSpinnerVisible: true });
    const { lcoID, lcoPassword, domainName } = this.state;
    API.getLOC_Details(lcoID, lcoPassword, "lcodetail", domainName)
      .then(response => response.json())
      .then(responsejson => {
        this.setState({
          lcoName: responsejson.lconame,
          lcoBalance: responsejson.balance,
          lcocode: responsejson.lcocode
        });
        this.getdata1();
      });
  }
  logOutFunc() {
    if (this.state.isloggedOut) {
      return <Redirect to="/login" />;
    } else {
      return null;
    }
  }
  logOut() {
    localStorage.removeItem("userID");
    const username = localStorage.getItem("userID");
    if (!username) {
      this.setState({ isloggedOut: true });
    }
  }
  backTOTrandactions() {
    this.props.onMoveToTransactions();
  }
  stockListSearch(text) {
 
    var { lcoID, lcoPassword, domainName, inStockListSearchText } = this.state;
    if (text.length > 2) {
        this.setState({ inStockDataList: [], isShowInStockList: true, isShowStockLoader: true, noData: "" });

        API.stockListSearch(lcoID, lcoPassword, "liststock", text, 1, domainName)
            .then((response) => response.json())
            .then((responseJson) => {
                console.log("response", responseJson);
                if (responseJson.count) {


                    this.setState({ inStockDataList: responseJson.content, isShowInStockList: true, inStockCurrentPage: 1, totalCountInStock: responseJson.count, isShowStockLoader: false });
                    console.log("In stock list", this.state.inStockDataList);
                } else {
                    this.setState({ inStockDataList: [], isShowStockLoader: false, noData: "No data found!" });
                }
            });
    } else {
        this.setState({ isShowInStockList: false, isShowInStockList: false, isShowStockLoader: false, noData: "" });
    }
}
getSTBDetails(item) {
    console.log("item", item);
    if (item.Customer) {
      this.setState({ spinnerVisible: true });
      const { lcoID, lcoPassword, domainName, searchText } = this.state;
      API.STBSearch(lcoID, lcoPassword, "stbsearch", item.SNo, domainName)
        .then((response) => response.json())
        .then((responsejson) => {
          console.log("response", responsejson);
          if (responsejson.message == "no data") {
            this.setState({ spinnerVisible: false });
          } else {
            localStorage.setItem("currentlco", item.Lcocode);
            this.setState({ spinnerVisible: false });
            this.props.moveToCustomerDetails("customerdetails", responsejson, this.state.searchText);
          }
        });
    }
    else {
      this.setState({ isShowNodataDialog: true })
    }

  }

  render() {
    return (
      <Rootcontainer onScroll={e => this.handleScroll(e)}>
        <LoadingOverlay
          className={this.state.isSpinnerVisible ? "displaySpinner" : ""}
          overlay={true}
          active={this.state.isSpinnerVisible}
          spinner={
            <img
              src={loadinggif}
              className="spinnerContent"
              color="green"
              style={{ marginLeft: 100 }}
            />
          }
        ></LoadingOverlay>
        <Drawer
          open={this.state.isShowLogOutDialog}
          onRequestClose={this.toggle}
          direction="left"
        >
          <Card>
            <Card.Body className="pl-3 pr-3">
              <div style={{ fontSize: 15, fontWeight: "bold" }}>
                Do you want{" "}
                <span style={{ fontSize: "1.5em", color: "red" }}>Log out</span>{" "}
                ?
              </div>
              <Undraw className="undrawimg" name="monitor" />
              <Button
                style={{ marginLeft: 20 }}
                className="success"
                className="mt-3 pull-right"
                onClick={() => {
                  this.setState({ isShowLogOutDialog: false });
                }}
              >
                Cancel
              </Button>

              <Button
                style={{ backgroundColor: "red" }}
                className="danger"
                className="mt-3 pull-right"
                onClick={() => {
                  // this.props.hindNodataDialog();
                  this.logOut();
                }}
              >
                OK
              </Button>
            </Card.Body>
          </Card>
        </Drawer>

        <div className="header-div">
          <MdArrowBack
            onClick={() => this.backTOTrandactions()}
            className="back-button"
          />
          <h3 style={{ marginLeft: "90px",textTransform:"uppercase",marginRight:"-30px"}}>Debit History</h3>
          <img
          onClick={()=>{this.props.moveToDashBoard()}}
            src={GeneralValues.circlelogo}
            style={{ float: "left", marginLeft: " -138px" }}
            className="logo-img"
            alt="logo"
          />

      <MdPowerSettingsNew
            onClick={() => {
              this.setState({ isShowLogOutDialog: true });
            }}
            value="Logout"
            className="fontSize login"
          />

<input type="text" text="Search" placeholder="Global Search..."
                       onChange={(e) => {
                           this.setState({ inStockListSearchText: e.target.value })
                           this.stockListSearch(e.target.value);
                       }}
 
                       value={this.state.inStockListSearchText}
                       className="input-STB"
                       style={{ backgroundColor: "transparent", borderColor: "transparent", borderBottom: "2px solid white", color: "white", textAlign: "center", fontSize: 15, borderRight: "2px solid white", fontWeight: "bold",alignSelf:"end",marginLeft:"50%" }} />
                   <div style={{
                       position: "absolute",
                       display: this.state.isShowInStockList ? "block" : "none",
                       listStyle: "none",
                       backgroundColor: "white",
                       padding: 0,
                       boxShadow: "0px 1px 3px #e9b42a",
                       zIndex: 9,
                       width: "22vw",
                       top: 60,
                       overflow: "auto",
                       maxHeight: "30vh",
                       marginLeft:"65%"
 
                   }}
                       onScroll={(e) => this.handleScroll(e)}>
                       <label style={{ fontSize: 15, fontWeight: "bold", color: "rgb(26, 172, 195)", marginLeft: 10 }}>List:</label>
                       <div style={{ textAlign: "center", color: "gray" }}>{this.state.noData}</div>
                       <ul style={{ listStyle: "none", padding: 10 }}>
 
                           {this.state.inStockDataList.map((item, i) => {
 
                               return (
 
 
                                   <li className="search-list"
                                       onClick={() => { this.getSTBDetails(item) }}
                                       style={{ fontSize: 15, color: "black", lineHeight: 2, borderBottom: "1px solid rgba(26, 172, 195,0.5)", cursor: "pointer" }}>
                                       <div>
                                           <lable style={{ display: "block" }}>
                                               Name:
  {item.Customer ? item.Customer : <FaPlus style={{
                                                   background: " #0a3f65",
                                                   color: "white", width: "20px", height: "20px", padding: "2px", borderRadius: "10px", marginLeft: "8px"
                                               }} />}
 
                                               <FaCircle style={{
                                                   display: item.status ? "inline-block" : "none",
                                                   height: "12px", float: "right", marginTop: "8px",
                                                   color: item.status == "Live" ? "green" : "red",
                                               }} />
 
 
                                           </lable>
 
                                           <lable style={{ display: "block" }}>STB: {item.SNo}
 
                                               <div style={{
                                                   fontSize: "12px", display: item.paid ? "inline-block" : "none", float: "right", color: "white",
                                                   padding: "0px 7px", height: "25px",
                                                   backgroundColor: item.paid === "paid" ? "green" : "red",
                                               }}>{item.paid}  </div>
                                           </lable>
 
                                           <lable style={{ display: "block", fontSize: "12px" }}>Lco: {item.Lconame}
 
                                               <div style={{ fontSize: "12px", display: "inline-block", float: "right", color: "red" }}>({item.Lcocode})
 </div>
                                           </lable>
                                       </div>
                                   </li>
 
                               );
                           })}
                       </ul>
 
                       <Loader
                           visible={this.state.isShowStockLoader}
                           style={{ textAlign: "center", marginBottom: 10, }}
                           type="ThreeDots"
                           color="#00BFFF"
                           height="10"
                           width="20"
                       />
                   </div>
        </div>

        <RootDiv>
          <RootLeft>
            <RootTitle>Name :</RootTitle>

            <RootValue
              style={{ cursor: "pointer",marginLeft:5 }}
              onClick={() => {
                this.props.onClickProfile();
              }}
            >
              {" "}{this.state.lcoName}
            </RootValue>
            <div className="lcocode">
              <span style={{ color: "black" }}>Partner code :</span>{" "}
              {this.state.lcocode}
            </div>
          </RootLeft>

          <RootRight>
            <RootTitle>Balance :</RootTitle>

            <RootValue>
              {"\u20B9"} {this.state.lcoBalance}
            </RootValue>
          </RootRight>
        </RootDiv>
        <MainContainer>
          <table className="table table-striped">
            <thead>
              <th>Packages</th>
              <th>Created</th>
              <th>Amount</th>
              <th>Tax Amount</th>
              <th>Total Amount</th>
              <th>Customer</th>
              <th>STB</th>
              <th>VC</th>
            </thead>
            <tbody className="total-records">
              {this.state.creditRow.map((data, i) => {
                return (
                  <tr>
                    <td>{data.pack}</td>
                    <td>{data.created}</td>
                    <td>{data.amount}</td>
                    <td>{data.taxamount}</td>
                    <td>{data.totalamount}</td>
                    <td>{data.customer}</td>
                    <td>{data.stb}</td>
                    <td>{data.vc}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>

          {/* <tbody className="total-records">
              {this.state.creditRow.map((data, i) => {
                return (
                  <tr>
                    <td>{data.pack}</td>
                    <td>{data.created}</td>
                    <td>{data.amount}</td>
                    <td>{data.taxamount}</td>
                    <td>{data.totalamount}</td>
                    <td>{data.customer}</td>
                    <td>{data.stb}</td>
                    <td>{data.vc}</td>
                  </tr>
                );
              })}
            </tbody> */}
        </MainContainer>

        {this.logOutFunc()}
      </Rootcontainer>
    );
  }
}
